import moment from 'moment';
import type { AppState } from '../../../../types/State';

export const getCalendarMinDate = (state: AppState): moment => state.session.radio.getCreatedAt();



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/selectors/metricsSelectors.js